import { render, staticRenderFns } from "./departmentModalUpdate.vue?vue&type=template&id=2fd54524&scoped=true&"
import script from "./departmentModalUpdate.vue?vue&type=script&lang=js&"
export * from "./departmentModalUpdate.vue?vue&type=script&lang=js&"
import style0 from "./departmentModalUpdate.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./departmentModalUpdate.vue?vue&type=style&index=1&id=2fd54524&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd54524",
  null
  
)

export default component.exports